export default "__VITE_ASSET__Dy7_pVO1__"